export enum SweatMatchPrioritiesEnum {
	Low = -1,
	Normal = 0,
	High = 1,
}
